export default "__VITE_ASSET__DEJjMylb__"